export class NotificationTypes {
  static Success = 'success';
  static Error = 'error';
}
